import { Card, Result, Typography } from "antd";
import { t } from "i18next";
import { Component, ErrorInfo } from "react";

interface Props {
  children: JSX.Element;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
  visible: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      visible: false,
    };
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: null, errorInfo: null, visible: false };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState((prevState) => ({
      ...prevState,
      error,
      errorInfo,
      visible: true,
    }));
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return (
        <Card>
          <Result
            status="error"
            title={t("something_went_wrong")}
            subTitle={
              <Typography.Text copyable>
                {this.state.error?.message}
              </Typography.Text>
            }
          />
          <Typography.Text>
            {this.state.errorInfo?.componentStack}
          </Typography.Text>
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
